import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Box, Typography, IconButton, InputAdornment } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../Service/admin";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import * as Styled from "./style";
import { signIn } from "../Redux/Reducers/UserSlice";
import { useDispatch } from "react-redux";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false);
  const [login, { isLoading }] = useLoginMutation();

  const schema = Yup.object().shape({
    username: Yup.string().trim().required("Username is required"),
    password: Yup.string().trim().required("Password is required"),
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const response = await login(data);
    if (!response?.error) {
      const token = response?.data?.token;
      dispatch(signIn({token}));
      navigate("/onboarding/admin");
    }
  };

  return (
    <Styled.Container>
      <Box
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
      >
        <Styled.Form onSubmit={handleSubmit(onSubmit)}>
          <Styled.IconButtonWrapper>
            <IconButton
              sx={{
                backgroundColor: "#f50057",
                borderRadius: "50%",
                padding: "10px",
              }}
            >
              <LockOutlinedIcon />
            </IconButton>
            <Styled.Title component="h1" variant="h5">
              Sign in
            </Styled.Title>
          </Styled.IconButtonWrapper>

          <Box mt={2}>
            <Box mt={1}>
              <Typography variant="body2">Username</Typography>
              <Controller
                name="username"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Styled.StyledTextField
                    placeholder="Enter your username"
                    {...field}
                    {...register("username")}
                    error={!!errors?.username}
                    helperText={errors?.username?.message}
                  />
                )}
              />
            </Box>

            <Box mt={2}>
              <Typography variant="body2">Password</Typography>
              <Controller
                name="password"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Styled.StyledTextField
                    type={visible ? "text" : "password"}
                    placeholder="Enter password"
                    {...field}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setVisible(!visible)}>
                            {visible ? (
                              <VisibilityIcon sx={{ fontSize: 20 }} />
                            ) : (
                              <VisibilityOffIcon sx={{ fontSize: 20 }} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={!!errors?.password}
                    helperText={errors?.password?.message}
                    autoComplete="current-password"
                  />
                )}
              />
            </Box>

            <Box mt={2}>
              <Styled.SubmitButton
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={isLoading}
              >
                Login
              </Styled.SubmitButton>
            </Box>
          </Box>
        </Styled.Form>
      </Box>
    </Styled.Container>
  );
};

export default Login;
